import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Account } from '@core/customer-space-admin/customer-space-user.model';

@Component({
  selector: 'app-display-account',
  template: `
    <div *ngIf="account.isInternal">Internal</div>
    <div *ngIf="!account.isInternal">External</div>
    <div *ngIf="account.isActive">Active</div>
    <div *ngIf="!account.isActive">Inactive</div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DisplayAccountComponent {
  @Input() account!: Account;
}
